/*eslint-disable*/
import React from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "components/customButtons/Button.js";

import styles from "assets/jss/components/headerLinksStyle.js";
import { links } from "./links";

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const classes = useStyles();
  return (
      <List className={classes.list}>
          { links.map((item) => {
              return (
                  <ListItem className={classes.listItem}>
                      <Tooltip
                          id={item.id}
                          title={item.tooltip}
                          placement={window.innerWidth > 959 ? "top" : "left"}
                          classes={{ tooltip: classes.tooltip }}
                      >
                          <Button
                              href={item.href}
                              color={item.color}
                              target={item.target}
                              className={classes.navLink}
                          >
                              <i className={classes.socialIcons + item.icon} />
                          </Button>
                      </Tooltip>
                  </ListItem>
              )
          })}
    </List>
  );
}
